import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import type { Detection } from '../../app/types';
import PageSection from '../shared/PageSection';

export default function DetectionsPage({ detections }: { detections: Detection[] }) {
  return (
    <PageSection title="Detections" subtitle="Detected faces captured from uploaded snapshots.">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Created</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Camera</TableCell>
            <TableCell>Snapshot</TableCell>
            <TableCell>Crop</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detections.map((detection) => (
            <TableRow key={detection.detectedFaceId}>
              <TableCell>{new Date(detection.createdAt).toLocaleString()}</TableCell>
              <TableCell>{detection.status}</TableCell>
              <TableCell>{detection.cameraId}</TableCell>
              <TableCell>{detection.snapshotId}</TableCell>
              <TableCell>{detection.cropObjectKey ?? 'Pending crop'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </PageSection>
  );
}
